import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { IconButton } from "@material-tailwind/react";
import { useState } from "react";
import toast from "react-hot-toast";
import { api } from "../../../../../../services/api/api";
import { showApiErrorToast } from "../../../../../../services/api/error";
import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import ReportForm from "../../../../../../components/data/report/ReportForm";
import DeleteReportItemModal from "./modals/DeleteReportItemModal";

export default function ReportAdminActions({
  report,
  onChange,
  disabled
}: {
  report: EasyTech.ReportItem,
  onChange: () => void,
  disabled?: boolean
}) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const updateReport = (data: EasyTech.ReportItem): Promise<void> => {
    return new Promise((resolve, reject) => {
      api.put(`admin/reports/${data.id}`, data).then(() => {
        onChange();
        toast.success("Report updated");
        resolve();
      }).catch((error) => {
        showApiErrorToast(error, { fallbackMessage: "Error updating report" });
        reject();
      });
    });
  };

  return (
    <div className="flex gap-2 justify-center">
      <EditCreateDrawer data={report}
        entityName="reports"
        FormComponent={ReportForm}
        isNotCreatable={true}
        onSubmit={updateReport}
        disabled={disabled} />
      <IconButton variant="text" color="blue" size="sm" onClick={() => setIsDeleteModalOpen(true)} className="icon-btn" disabled={disabled}>
        <TrashIcon className="h-5 w-5" />
      </IconButton>

      <DeleteReportItemModal
        open={isDeleteModalOpen}
        report={report}
        onDelete={onChange}
        onClose={() => setIsDeleteModalOpen(false)}
      />
    </div>
  );
}
